module.exports = __webpack_public_path__ + "static/step5-c73c54eb675bfb1a6143335d7919f937.png";